import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { LazyImgDirective } from "../lazy-img.directive";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-surgery-home",
  templateUrl: "./surgery-home.component.html",
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, MatButton]
})
export class SurgeryHomeComponent implements OnInit {
  revolution: any;

  @Input() surgery_data: any;

  constructor() {}

  ngOnInit() {}
}
